<template>
  <div class='wrap-rule'>
    <img class="rule-img" :src="bgUrl" alt="">
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import { getQueryString } from '@/utils/tools'

const bgUrl = ref('https://img11.litenews.cn/29/2024/02/26/ed6d33c1112ed65dece5d619b34cb57d.jpeg')

onMounted(() => {
  if (getQueryString('questionActiveKey') === '6128399304d94a3c9e7ec1348418d2c8') {
    bgUrl.value = 'https://img11.litenews.cn/29/2024/08/16/9c9330b34e54597e079efe19e8d6ef0a.png'
  }
  if (getQueryString('questionActiveKey') === 'fc71275f0e8947598b3fa404111ed9f0') {
    bgUrl.value = 'https://img11.litenews.cn/29/2024/09/06/9f7e2d06d2a886d2fc213c49da1505df.png'
  }
})
</script>


<style scoped lang='scss'>
.wrap-rule {
  width: 750px;
  height: 1400px;
  // background-image: url("https://img11.litenews.cn/29/2024/02/26/ed6d33c1112ed65dece5d619b34cb57d.jpeg");
  // background-size: contain;
  // background-repeat: no-repeat;

  .rule-img {
    width: 100%;
    object-fit: contain;
  }
}

</style>
